import { COMPLETESESSION_FAILURE, COMPLETESESSION_REQUEST, COMPLETESESSION_SUCCESS } from "../action/Completedsession";


const initialState = {
  sessioncompleteData: null,
  loading: false,
  error: null,
  userData: ''

};

const completesessionReducer = (state = initialState, action) => {
  switch (action.type) {
    case COMPLETESESSION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case COMPLETESESSION_SUCCESS:
      return {
        ...state,
        loading: false,
        sessioncompleteData: action.payload,
      };
    case COMPLETESESSION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default completesessionReducer;
